/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userentityfilters2Inputs */

const en_entity_userentityfilters2 = /** @type {(inputs: Entity_Userentityfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Entity Filters`)
};

const de_entity_userentityfilters2 = /** @type {(inputs: Entity_Userentityfilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-Entitätenfilter`)
};

/**
* | output |
* | --- |
* | "User Entity Filters" |
*
* @param {Entity_Userentityfilters2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userentityfilters2 = /** @type {((inputs?: Entity_Userentityfilters2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userentityfilters2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userentityfilters2(inputs)
	return de_entity_userentityfilters2(inputs)
});
export { entity_userentityfilters2 as "entity_userEntityFilters" }